import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const anyFilterAppliedSelector = (state: RootState) => {
  const filter = resourceExplorerAppliedFiltersSelector(state);

  return !!(filter.aws || filter.gcp || filter.azure);
};
